var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-uploader',{attrs:{"max-count":1,"after-read":_vm.afterRead},model:{value:(_vm.bankCard),callback:function ($$v) {_vm.bankCard=$$v},expression:"bankCard"}})}
var staticRenderFns = []

export { render, staticRenderFns }